import React, {Component} from 'react'
import {connect} from 'react-redux'
import {arrayMove} from 'react-sortable-hoc';
import CategoryAccordion from "../../common/category-accordion";
import {history} from '../../../../../store'
import ConfirmPopup from "../../../../common/confirm-popup";
import {deleteProduct, reorderProducts} from '../../../../../actions/products'
import {reorderBrands} from "../../../../../actions/brands";

class ProductsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    }
  }

  traverseProducts = (products) => {
    const categories = [...products];

    categories.forEach(category => {
      category.attributes.brands.forEach(brand => {
        brand.products = category.attributes.products.filter(product => product.brand_id === brand.id);
      })
    });

    return categories;
  };

  toggleDeletePopup = (id) => {
    this.setState({delete: {show: !this.state.delete.show, id: id}});
  };

  handleDelete = (result) => {
    const id = this.state.delete.id;
    this.setState({delete: {show: false}});
    if(result) {
      this.props.dispatch(deleteProduct(id));
    }
  };

  handleEdit = (id) => {
    history.push(`/admin/products/${id}`);
  };

  handleSort = (categoryId, brandId, oldIndex, newIndex) => {
    const {dispatch} = this.props;

    if(oldIndex !== newIndex){
      const category    = this.props.products.find(category => category.id === categoryId);
      const brand       = category.attributes.brands.find(brand => brand.id === brandId);
      const newOrdering = arrayMove(brand.products, oldIndex, newIndex);
      dispatch(reorderProducts(categoryId, brandId, newOrdering))
    }
  };

  render(){
    const categories = this.traverseProducts(this.props.products);

    return(
      <div>
        <CategoryAccordion categories={categories}
                           itemName="products"
                           statusAttribute="stock_status"
                           onDelete={this.toggleDeletePopup}
                           onEdit={this.handleEdit}
                           onSortEnd={this.handleSort}/>

        {
          this.state.delete.show &&
          <ConfirmPopup header="DELETE PRODUCT?"
                        onClose={this.handleDelete}>
            <p>Are you sure you want to delete this product?</p>
          </ConfirmPopup>
        }
      </div>
    )
  }
}

export default connect()(ProductsList)


// WEBPACK FOOTER //
// ./src/components/admin/products/products/list/products-list.jsx